<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Cobradores</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Cobradores</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button
      type="button"
      class="float-right"
      mdbBtn
      color="info"
      data-target="#basicExample"
      (click)="centralLarge.show()"
      mdbWavesEffect
      size="sm"
    >
      Agregar
    </button>

    <div
      mdbModal
      #centralLarge="mdb-modal"
      class="modal fade"
      id="basicExample"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      [config]="{ backdrop: true, ignoreBackdropClick: true }"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title w-100 text-left" id="myModalLabel">
              Agregar
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              (click)="centralLarge.hide()"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input
                      value="0"
                      id="cobid"
                      class="form-control"
                      placeholder="ID"
                      type="hidden"
                      #cobid
                    />
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="cobcodigo"
                      class="form-control"
                      [(ngModel)]="selectedCobrador.cobcodigo"
                      maxLength="3"
                      placeholder="Codigo"
                      required
                      #cobcodigo
                    />
                    <label for="cobcodigo">Codigo</label>
                  </div>
                  <div class="md-form">
                    <input
                      placeholder="nombre"
                      class="form-control"
                      type="text"
                      id="cobnombre"
                      [(ngModel)]="selectedCobrador.cobnombre"
                      maxLength="200"
                      required
                      value=""
                      #cobnombre
                    />
                    <label for="cobnombre">Nombre</label>
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="cobrut"
                      class="form-control"
                      placeholder="RUT"
                      [(ngModel)]="selectedCobrador.cobrut"
                      maxLength="10"
                      required
                      #cobrut
                    />
                    <label for="cobrut">RUT</label>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input
                      placeholder="Cargo"
                      class="form-control"
                      type="text"
                      id="cobcargo"
                      [(ngModel)]="selectedCobrador.cobcargo"
                      required
                      value=""
                      #cobcargo
                    />
                    <label for="cobcargo">Cargo</label>
                  </div>
                  <div class="md-form">
                    <input
                      placeholder="Zona"
                      class="form-control"
                      type="text"
                      id="cobzona"
                      [(ngModel)]="selectedCobrador.cobzona"
                      required
                      value=""
                      #cobzona
                    />
                    <label for="cobzona">Zona</label>
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="cobseccion"
                      class="form-control"
                      [(ngModel)]="selectedCobrador.cobseccion"
                      placeholder="Seccion"
                      #cobseccion
                    />
                    <label for="cobseccion">Seccion</label>
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="number"
                      step="any"
                      id="cobcomision"
                      class="form-control"
                      [(ngModel)]="selectedCobrador.cobcomision"
                      placeholder="Comision"
                      #cobcomision
                    />
                    <label for="cobcomision">Comision</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-default waves-light"
              data-dismiss="modal"
              (click)="centralLarge.hide()"
              mdbWavesEffect
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-secondary waves-light"
              mdbWavesEffect
              (click)="
                insertar(
                  cobid.value,
                  cobcodigo.value,
                  cobnombre.value,
                  cobrut.value,
                  cobcargo.value,
                  cobzona.value,
                  cobseccion.value,
                  cobcomision.value
                );
                centralLarge.hide()
              "
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      mdbModal
      #centralLargex="mdb-modal"
      class="modal fade"
      id="basicExamplex"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      [config]="{ backdrop: true, ignoreBackdropClick: true }"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title w-100 text-left" id="myModalLabel">
              Modificar Cobrador
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              (click)="centralLargex.hide()"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input
                      id="cobidx"
                      [(ngModel)]="selectedCobrador.cobid"
                      class="form-control"
                      type="hidden"
                      #cobidx
                    />
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="cobcodigox"
                      [(ngModel)]="selectedCobrador.cobcodigo"
                      class="form-control"
                      maxLength="3"
                      required
                      #cobcodigox
                    />
                    <label for="cobcodigox">Codigo</label>
                  </div>
                  <div class="md-form">
                    <input
                      placeholder="Nombre"
                      [(ngModel)]="selectedCobrador.cobnombre"
                      class="form-control"
                      type="text"
                      id="cobnombrex"
                      maxLength="200"
                      required
                      #cobnombrex
                    />
                    <label for="cobnombrex">Nombre</label>
                  </div>
                  <div class="md-form">
                    <input
                      type="text"
                      id="cobrutx"
                      [(ngModel)]="selectedCobrador.cobrut"
                      class="form-control"
                      pattern="\d{3,8}-[\d|kK]{1}"
                      title="Debe ser un Rut válido"
                      maxLength="10"
                      required
                      #cobrutx
                    />
                    <label for="cobrutx">RUT</label>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input
                      type="text"
                      id="cobcargox"
                      [(ngModel)]="selectedCobrador.cobcargo"
                      class="form-control"
                      placeholder="Cargo"
                      #cobcargox
                    />
                    <label for="cobcargox">Cargo</label>
                  </div>
                  <div class="md-form">
                    <input
                      type="text"
                      id="cobzonax"
                      [(ngModel)]="selectedCobrador.cobzona"
                      class="form-control"
                      #cobzonax
                    />
                    <label for="cobzonax">Zona</label>
                  </div>
                  <div class="md-form">
                    <input
                      type="text"
                      id="cobseccionx"
                      [(ngModel)]="selectedCobrador.cobseccion"
                      class="form-control"
                      #cobseccionx
                    />
                    <label for="cobseccionx">Seccion</label>
                  </div>
                  <div class="md-form">
                    <input
                      type="text"
                      id="cobcomisionx"
                      [(ngModel)]="selectedCobrador.cobcomision"
                      class="form-control"
                      #cobcomisionx
                    />
                    <label for="cobcomisionx">Comision</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-default waves-light"
              data-dismiss="modal"
              (click)="centralLargex.hide()"
              mdbWavesEffect
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-secondary waves-light"
              mdbWavesEffect
              (click)="
                actualizar(
                  cobidx.value,
                  cobcodigox.value,
                  cobnombrex.value,
                  cobrutx.value,
                  cobcargox.value,
                  cobzonax.value,
                  cobseccionx.value,
                  cobcomisionx.value
                )
              "
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <input type="checkbox" (ngModel)="(true)" />

      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Codigo</th>
            <th scope="col">Nombre</th>
            <th scope="col">RUT</th>
            <th scope="col">Cargo</th>
            <th scope="col">Zona</th>
            <th scope="col">Seccion</th>
            <th scope="col">Comision</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cob of cobradorList">
            <td>{{ cob.cobid }}</td>
            <td>{{ cob.cobcodigo }}</td>
            <td>{{ cob.cobnombre }}</td>
            <td>{{ cob.cobrut }}</td>
            <td>{{ cob.cobcargo }}</td>
            <td>{{ cob.cobzona }}</td>
            <td>{{ cob.cobseccion }}</td>
            <td>{{ cob.cobcomision }}</td>
            <td>
              <button
                class="btn-actions-sm"
                color="info"
                mdbBtn
                type="button"
                size="sm"
                mdbWavesEffect
                data-toggle="modal"
                data-target="#basicExamplex"
                (click)="centralLargex.show()"
                mdbTooltip="Ver"
                placement="right"
              >
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              <button
                class="btn-actions-sm"
                color="primary"
                mdbBtn
                type="button"
                mdbWavesEffect
                mdbTooltip="Eliminar"
                placement="right"
              >
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
